import obx_dates from "./osx_dates.json";
import obx_stocks from "./osx_stocks.json";

export const BehaviourData = () => {
  const stockPrices = [] as number[];
  const dates = [] as string[];

  obx_dates.forEach((_, i) => {
    dates.push(obx_dates[i].Date);
    stockPrices.push(obx_stocks[i].Price);
  });

  dates.reverse();
  stockPrices.reverse();

  const dataSet = { xData: dates, yData: stockPrices };
  const processedData = dataSet.yData.map((dataEl, i) => {
    return [new Date(dataSet.xData[i]).getTime(), dataEl];
  });

  return {
    chart: { type: "line" },
    credits: { enabled: false },
    accessibility: { enabled: false },
    title: null,
    xAxis: { title: null, type: "datetime", tickInterval: 24 * 3600 * 1000 },
    yAxis: { title: null },
    legend: { enabled: false },
    tooltip: {
      xDateFormat: "%d.%m.%Y",
      crosshairs: { color: "var(--color-yellow)", zIndex: 3, dashStyle: "dash" },
      backgroundColor: "var(--color-white)",
      borderColor: "var(--color-darkBlue)",
      borderRadius: 0,
      shadow: false,
    },
    series: [{ data: processedData, name: "Oslo Børs" }],
  };
};
